<template>
  <div>
      <home />
  </div>
</template>

<script>
import home from "../components/HomeSection";

export default {
  name: "Home",

  components: {
    home,
  },

  data: () => ({

  }),

  created() {

  },

  watch: {

  },

  methods: {

  },
};
</script>
